import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Stock } from 'src/app/shared/models/stock.model';

@Component({
  selector: 'app-stock-create-modal',
  templateUrl: './stock-create-modal.component.html',
  styleUrls: ['./stock-create-modal.component.scss']
})
export class StockCreateModalComponent implements OnInit {

  stockForm: FormGroup;
  @Input() stock: Stock;
  isEdit: boolean;

  constructor(public activeModal: NgbActiveModal,
              private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.stockForm = this.formBuilder.group({
      stock_id   : [0],
      name       : ['', [Validators.required, Validators.maxLength(50)]],
      description: ['', [Validators.maxLength(250)]]
    });

    if (this.stock) {
      this.isEdit = true;
      this.stockForm.patchValue({
          stock_id   : this.stock.stock_id,
          name       : this.stock.name,
          description: this.stock.description
        });

      this.stockForm.updateValueAndValidity();
    }
  }

  close() {
    this.activeModal.close(
      this.stockForm.value
    );
  }
}
